import React from 'react';
import styled from 'styled-components';
import { certifications } from '../../data/constants';
import CertificateCard from '../Cards/CertificateCard';
import SectionHeading from '../common/SectionHeading';

const Section = styled.section`
  width: 100%;
  padding: 120px 24px;
  background: linear-gradient(180deg, rgba(133, 76, 230, 0.05), transparent);
`;

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 24px;
`;

const Certifications = () => (
  <Section id="certifications">
    <Wrapper>
      <SectionHeading
        eyebrow="Credentials"
        title="Industry-recognized certifications that back practice with rigor"
        description="Ongoing learning across AI, cloud, full-stack engineering, and product leadership."
      />
      <CardsGrid>
        {certifications.map((item) => (
          <CertificateCard key={item.id || item.title} certificate={item} />
        ))}
      </CardsGrid>
    </Wrapper>
  </Section>
);

export default Certifications;
